import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import BookmarkIcon from '@material-ui/icons/BookmarkBorder';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

import HorizontalSlider from './HorizontalSlider';
// import PhotoSlider from './PhotoSlider';

const styles = theme => ({
  mainContainer: {
    padding: "20px"
  },
  slideContainer: {
    marginTop: "20px"
  },
  actions: {
    marginTop: "20px",
    backgroundColor: theme.palette.primary.main,
    height: "40px"
  },
  actionIcon: {
    backgroundColor: theme.palette.secondary.main,
    color: "white",
    margin: "5px",
    marginTop: "-30px",
    boxShadow: "1px 1px grey"
  },
  inline: {
    display: 'inline',
  },
  pushRight: {
    marginLeft: 'auto',
  },
});

class MainListicle extends React.Component {
  render() {
    const { classes, eateryItem } = this.props;
    const eatery = eateryItem.eatery;
    const eateryPhotos = eateryItem.images.map((photo, i) => (
      // <PhotoSlider key={"gallery" + i} photo={photo} /> comment to be removed when user is given option to upload images for each eatery
      <img key={"gallery" + i} src={photo.uri} style={{ width: "100%" }} alt="" />
    ));
    const dishes = eatery.mustTryDishes.dishes.map((dish, i) => {
      return dish.name;
    });
    let eaterySummary = (eatery.summary.split(" ").length > 20) ? eatery.summary.split(" ").slice(0, 20).join(" ") + " ..." : eatery.summary;
    return (
      <div className={classes.mainContainer}>
        <Card>
          <CardHeader
            title={eatery.name}
            subheader={
              <Fragment>
                <Typography
                  variant="subtitle2"
                  classes={{ root: classes.inline }}
                >
                  {eatery.location.locality + ", " + eatery.city.name}
                </Typography>
              </Fragment>
            }
          />
          <div className={classes.slideContainer}>
            <Grid item xs={12} className={classes.eateryPhotos}>
              <div>
                <HorizontalSlider>{eateryPhotos}</HorizontalSlider>
              </div>
            </Grid>
          </div>
          <CardContent>
            <Typography variant="subtitle1">
              Must Try Dishes
            </Typography>
            <Typography variant="subtitle2">
              {dishes.join(" • ")}
            </Typography>
            <br />
            <Typography variant="body2">
              {eaterySummary}
            </Typography>
          </CardContent>
          <CardActions className={classes.actions} disableActionSpacing>
            <div className={classes.pushRight}>
              <IconButton
                className={classes.actionIcon}
                color="secondary"
                aria-label="Bookmark"
              >
                <BookmarkIcon />
              </IconButton>
            </div>
          </CardActions>
        </Card>
        <Typography variant="body1" style={{ whiteSpace: "pre-wrap" }}>{eateryItem.description}</Typography>
      </div>
    );
  }
}

MainListicle.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MainListicle);
